<template>
  <div class="index" v-cloak>
    
    <div class="wrapper">
      <SYCodeList :good-list="resData" :is-sort="false" v-if="resData.length > 0"></SYCodeList>

      <div class="title acea-row row-between-wrapper" v-if="resData.length < 1">
        <div class="noData">
          暂无数据
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import SYCodeList from "@components/SYCodeList";
import { getCodeList } from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAppMessage, openShareTimeline, ready } from "@libs/wechat";
import { isWeixin } from "@utils/index";

const HAS_COUPON_WINDOW = "has_coupon_window";

export default {
  name: "user",
  components: {
    swiper,
    swiperSlide,
    SYCodeList
  },
  props: {},
  data: function() {
    return {
      resData:[],
      showCoupon: false,
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: [],
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      },
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      }
    };
  },
  mounted: function() {
    let that = this;
    let openid = cookie.get("lishu-openid");
    console.log("mounted ----- ");

    if (openid) {
      getCodeList(1, 100, openid).then(data => {
      console.log(data);
      if (data.code == 0) {
        that.$set(that, "resData", data.data);
        console.log("resData");
      }else if (data.code == 301){
        this.$router.push({
            path: "/user/binding"
        });
      }
      console.log(that.resData);
      });
    }
  },
  methods: {
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    setOpenShare: function() {
      getShare().then(res => {
        var data = res.data.data;
        var configAppMessage = {
          desc: data.synopsis,
          title: data.title,
          link: location.href,
          imgUrl: data.img
        };
        var configTimeline = {
          title: data.title,
          link: location.href,
          imgUrl: data.img
        };
        if (isWeixin() === true) {
          ready().then(() => {
            openShareAppMessage(configAppMessage).then(() => {});
            openShareTimeline(configTimeline).then(() => {});
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.index {
  background-color: #fff;
}
.noData {
  font-size: 20px;
  color: #888888;
  margin:0 auto;
  margin-top: 50%;
}

.syTitle {
  background-color: #e93323;
  color: #fff;
  font-size: 20px;
}
</style>
